import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import { commonButton } from './styleMixins'

export const ThemedButton = styled.button<StyledHTMLElement>(({ theme }) => ({
  ...commonButton(theme),
  cursor: 'pointer'
}))
